const TaxIdentificationNumberDirective = angular
    .module("TaxIdentificationNumberDirective", [])
    .directive("taxIdentificationNumber", taxIdentificationNumber);

/**
 * @see http://stackoverflow.com/a/19228302/4454238
 */
function taxIdentificationNumber() {
    return {
        require: "ngModel",
        restrict: "A",
        priority: 1000,
        link: function (scope, element, attr, ctrl) {
            var pattern = /^\d{9}$/;
            var maskPattern = /^\W{2}-\W{3}\d{4}/;

            ctrl.$validators.tinDigits = function (modelValue) {
                if (ctrl.$isEmpty(modelValue)) {
                    // consider empty models to be valid
                    return true;
                }
                if (pattern.test(modelValue)) {
                    // it is valid
                    return true;
                }
                if (maskPattern.test(modelValue)) {
                    // it is valid
                    return true;
                }
                // it is invalid
                return false;
            };
        }
    };
}

export default TaxIdentificationNumberDirective;
